import { useEffect, useState } from "react";
import { api } from "../pages/SupplyDispatch/api";
export default function useSupplyDispatchAccess(userId, token, disabled) {
  const [access, setAccess] = useState({ actions: [], loading: true });
  useEffect(() => {
    let current = true;
    const refresh = async () => {
      if (!userId || !token || disabled) {
        if (current) setAccess({ actions: [], loading: false });
        return;
      }
      try {
        const data = await api("acceso");
        if (current) setAccess({ actions: data.actions, canRequest: data.canRequest === true, loading: false });
      } catch (error) {
        if (current)
          setAccess({ actions: [], loading: false, error: error.message });
      }
    };
    setAccess({ actions: [], loading: true });
    refresh();
    window.addEventListener("focus", refresh);
    window.addEventListener("supply-access-changed", refresh);
    const timer = setInterval(refresh, 60000);
    return () => {
      current = false;
      clearInterval(timer);
      window.removeEventListener("focus", refresh);
      window.removeEventListener("supply-access-changed", refresh);
    };
  }, [userId, token, disabled]);
  return access;
}

